import { useState } from 'react'
import { FarmFormDialog } from './FarmForm'
import { UserId } from '@cibo/core'

type FarmDialogProps = {
  farmId?: string
  onSuccess?: (result: any) => void
  ownerId?: UserId
}

export const useFarmDialog = () => {
  const [dialogState, setDialogState] = useState<
    FarmDialogProps & {
      open: boolean
    }
  >({
    open: false,
  })

  return {
    openFarmDialog: (props: FarmDialogProps) => setDialogState({ open: true, ...props }),
    farmDialog: (
      <FarmFormDialog
        open={dialogState.open}
        farmId={dialogState.farmId}
        onCancel={() => setDialogState({ open: false })}
        onSuccess={(result: any) => {
          setDialogState({ open: false })
          dialogState?.onSuccess && dialogState.onSuccess(result)
        }}
        ownerId={dialogState.ownerId}
      />
    ),
  }
}

export type UseFarmDialog = ReturnType<typeof useFarmDialog>
